<template>
	<div class="form-group base-textarea">
		<label v-if="label" for="baseTextarea">{{ label }}</label>
		<textarea
			class="form-control"
			id="baseTextarea"
			:value="value"
			v-bind="$attrs"
			@input="valueUpdate"
		></textarea>
		<p class="errorMsg" v-if="errorMsg">{{ errorMsg }}</p>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		label: {
			type: String
		},
		value: {
			type: [String, Number]
		},
		errorMsg: {
			type: String
		}
	},
	methods: {
		valueUpdate(e) {
			let value = e.target.value
			this.$emit('input', value)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/baseTextarea.scss';
</style>
